import apiClient from './apiClient';

export async function fetchPolicies() {
  const { data } = await apiClient.get('/policies');
  return data;
}

export async function setPolicyActive(id, active) {
  const { data } = await apiClient.patch(`/policies/${id}`, { active });
  return data;
}

export async function createPolicy(payload) {
  const { data } = await apiClient.post('/policies', payload);
  return data;
}

export async function updatePolicy(id, changes) {
  const { data } = await apiClient.patch(`/policies/${id}`, changes);
  return data;
}
